import React, { act, useEffect, useRef, useState } from "react";
import SubStep2 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep2";
import SubStep4 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep4";
import NOCTakeAction from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCTakeAction";
import IdentifyNoc from "../../citizen/AVPForms/reusableComponents/IdentifyNoc";
import Step2 from "../../citizen/AVPForms/formComponents/map-submission/Step2";
import CompoundingChecklist from "@egovernments/digit-ui-module-common/src/sharedComponents/CompoundingChecklist";
import Step4 from "../../citizen/AVPForms/formComponents/map-submission/Step4";
import Step4Comp from "../../citizen/AVPForms/formComponents/map-submission/Step4Comp";
import SearchSummary from "../../citizen/AVPForms/formComponents/map-submission/Summary/SearchSummary";
import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import Step6 from "../../citizen/AVPForms/formComponents/map-submission/Step6";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import FormStrip from "../../citizen/AVPForms/components/FormStrip";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import getMapSubmissionData from "../../citizen/AVPForms/formComponents/compounding-module/getMapSubmissionData";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import SubStep1 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep3";
import useEmpMapSubmission from "./useEmpMapSubmission";
import Step5 from "../../citizen/AVPForms/formComponents/map-submission/Step5";
import { Button, Card } from "@mui/material";
import InvitationSuggestion from "../../citizen/AVPForms/formComponents/map-submission/Step1/InvitationSuggestion";
import TakeActionItem from "../../../../../templates/Forms/TakeActionItem";
import BasicSiteInspectionReport from "../ScheduleInspection/basicSiteInspectionReport";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";
import { siteInspRecommendation } from "../../citizen/TCPForms/data";
import DetailInfoTable from "../AllViewRemarks";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import RecommendationRemarksComponent from "../RecommendationComponent";
import PaymentHead from "./PaymentHead";
import PaymentMemoTable from "../AllViewRemarks/PaymentChallan/PaymentMemoDetails";
import CompoundingFeeContainer from "./PaymentHeadCompounding";
import DrawingsDetailsTable from "../AllViewRemarks/DrawingsTable";
import EmpIdentifyNoc from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpIdentifyNoc";
import DscLetters from "../DigitalSignLetters";
import CollapsibleAdditionalRemarks from "../AdditionalRemarks";
import ChatBoard from "../../../components/ChatBoard";
import SubStep6 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep6";
import { departmentList } from "../../citizen/TCPForms/data";

const EmpCompoundingPortal = ({ formData, refetch, submitAction, workflowDetails, userRolesArray }) => {
  const {
    t,
    params,
    setParams,
    clearParams,
    isCitizen,
    callNotingDetailsAPI,
    notingRemarksData,
    developerRemarks,
    setDeveloperRemarks,
    currentAction,
    mapSubmissionAction,
    onDropDownSelect,
    remarks,
    setRemarks,
    actions,
    uploadedFile,
    setUploadedFile,
    handleSubmit,
    error,
    setError,
    updateApiCall,
    documentSection,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    currentView,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    handleDocView,
    handleNoWorkflow,
    documentRemarksData,
    developerNocRemarks,
    isValidEmp,
    taxHead,
    setTaxHead,
    isFeesEligible,
    dataRecommendation,
    daLogo,
    avpLogo,
    setDataRecommendation,
    paymentHeadRemarksData,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callDocumentDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    setUpdatedInspectionReportData,
    callInspectionDetailsAPI,
    handleNoWorkflowNoc,
    currentFormData,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);

  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [summaryShow, setSummaryshow] = useState(Digit?.SessionStorage.get("SUMMARY_TAB") || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = Digit.UserService.getUser()?.info;
  const userType = info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const history = useHistory();
  const location = useLocation();
  let applicationData = location.state?.data;
  let isAppDataLoading = false;
  const isJE = userRolesArray?.[0]?.code === "JE";

  console.log(applicationData, "applicationDataadata");
  const isSelfCert =
    applicationData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    applicationData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";

  const componentRef = useRef();
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "Land/Plot Information" },
    { label: "Invitation Suggestion" },
    // { label: "NOC Status" },
  ];

  const subTabDocLabels = [{ label: "Mandatory Documents" }, { label: "Conditional Documents" }];
  const closeToast = () => {
    setShowToast(null);
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  console.log("parmsfromPortalMapSubmission", params, params?.nocList?.length, workflowDetails);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  // const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);

  const isCompounding = params?.natureOfConstruction === "Compounding";
  console.log("hhjjkkklll", formData);

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      console.log("fromHandleTabchange", data, formData, work);
      const isApprovedMapSubmission = data?.applicationStatus === "APPROVED";

      const isSelfCert =
        params?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
        params?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        if (nextTabNo === 5 && params?.status !== "REVERT_TO_APPLICANT") {
          data.workflow = { action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT", assignes: null };
        } else if (nextTabNo === 5 && params?.status === "REVERT_TO_APPLICANT") {
          data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: () => {
              onSelect("", data);
              if (nextTabNo === 5) {
                if (params?.status === "REVERT_TO_APPLICANT") {
                  Modal(
                    "Application Submited",
                    `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                    "success"
                  );
                } else {
                  if (isSelfCert) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else if (params?.taxHeadEstimates?.length > 1) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  }
                  //   Modal(
                  //     "Application Submited",
                  //     `Your Application ${params?.applicationNo} has been sent to the plot Owner for his consent`,
                  //     "success"
                  //   );
                  // }
                  clearParams();
                  Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                  Digit?.SessionStorage.del("EDCR_CREATE");
                  Digit?.SessionStorage.del("FASTPAS_ID");
                  Digit?.SessionStorage.del("SUMMARY_TAB");
                  setTimeout(() => {
                    resetFormMTDocs();
                  }, 0);
                  Digit.SessionStorage.del("MS_CURRENT_TAB");
                  Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
                  //history.push(`${citizenBaseUrl}/profile`);
                }
              } else {
                if (nextTabNo === 5) {
                  Digit.SessionStorage.set("SUMMARY_TAB", true);
                  setSummaryshow(true);
                }
                //  Modal(
                //   "Application Updated",
                //   `Application Updated Successfully!`,
                //   "success"
                // )

                setShowToast({ error: false, message: `Data has been saved successfully` });
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
                // setActiveTab(nextTabNo);
                // Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo)
              }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  // const handleSubTabChange = (nextSubTab, formData = null) => {
  //   if (formData) {
  //     const data = { ...params, ...formData };
  //     if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !isCompounding) {
  //       Digit.OBPSService.create({ BPA: data }, tenantId)
  //         .then((res) => {
  //           if (res?.BPA?.length > 0) {
  //             onSelect("", { ...data, ...res.BPA[0] }, true);
  //             setShowToast({
  //               error: false,
  //               message: `Application Created Successfully!`,
  //             });
  //             setSelectedSubTab(nextSubTab);
  //             Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  //           }
  //         })
  //         .catch((e) => {
  //           Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
  //         });
  //     } else {
  //       try {
  //         data.workflow = { action: "UPLOAD_DOC", assignes: null };
  //         updateApiCall.mutate(
  //           { BPA: data },
  //           {
  //             onSuccess: (res) => {
  //               onSelect("", res?.BPA?.[0]);
  //               setShowToast({ error: false, message: `Data has been saved successfully` });
  //               setSelectedSubTab(nextSubTab);
  //               Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  //             },
  //             onError: () => {
  //               Modal("Update Error", "Something went wrong!!", "error");
  //             },
  //           }
  //         );
  //       } catch (error) {
  //         console.error(error);
  //         Modal("Update Error", "Something went wrong!!", "error");
  //       }
  //     }
  //   } else {
  //     setSelectedSubTab(nextSubTab);
  //     Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  //   }
  // };

  const handleSubTabChange = (nextSubTab) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };

  const handleSubDocTabChange = (nextSubTab) => {
    setSelectedDocTab(nextSubTab);
  };

  const handleInvitationSuggestionSave = (formData) => {
    try {
      const pressDetailsObj = {
        ...(params?.pressDetails || {}),
        ...(params?.pressReleaseDetails || {}),
        ...(formData?.pressDetails || {}),
        ...(formData?.pressReleaseDetails || {}),
        hasSuggestion: formData?.hasSuggestion,
        pressReleaseFee: formData?.pressReleaseFee,
        invitationRemark: formData?.invitationRemark,
      };

      const data = {
        ...params,
        ...formData,
        hasSuggestion: formData?.hasSuggestion,
        pressReleaseFee: formData?.pressReleaseFee,
        invitationRemark: formData?.invitationRemark,
        pressDetails: pressDetailsObj,
        pressReleaseDetails: pressDetailsObj,
        workflow: {
          action: "NOWORKFLOW",
          comments: "",
        },
      };

      updateApiCall.mutate(
        { BPA: data },
        {
          onSuccess: (res) => {
            onSelect("", res?.BPA?.[0]);
            setShowToast({ error: false, message: "Data has been saved successfully" });
            handleTabChange(1);
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          },
        }
      );
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 1:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 2:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 4:
          return (
            <SubStep6
              formData={formData}
              handleSubTabChange={handleSubTabChange}
              handleTabChange={handleTabChange}
              t={t}
              tenantId={tenantId}
              departmentList={departmentList}
              avpData={null}
              isEmployee={!isCitizen}
              isApproved={true}
            />
          );
        case 5:
          return (
            <InvitationSuggestion
              formData={formData}
              handleTabChange={handleTabChange}
              isEmployee={!isCitizen}
              isApproved={true}
              onSaveClick={handleInvitationSuggestionSave}
            />
          );

        // return <LandUseNOC formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
        // <SubStep5 formData={params} role="APPROVED_CITIZEN" handleTabChange={handleTabChange} handleSubTabChange={handleSubTabChange} isEmployees={isEmployee}/>;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return (
        <React.Fragment>
          <div className="view-doc-container">
            <Button
              variant="contained"
              className="view-doc-btn"
              onClick={handleDocView}
              style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
            >
              <span className="view-doc-icon">
                <ViewSidebarIcon />
              </span>
              {currentView === "documents" ? "View all documents" : "View document section"}
            </Button>
          </div>
          {currentView === "documents" ? (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={updatedDocuments}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={params?.documents || formData?.documents}
                docType="mandatory"
                callDocumentDetailsAPI={callDocumentDetailsAPI}
                detailData={documentRemarksData?.DetailDataRemarks}
                developerRemarks={developerRemarksDocument}
                setError={setError}
                ComposableComponent={(props) => (
                  <RecommendationRemarksComponent
                    formData={formData}
                    title="Recommendation Details"
                    label="Recommendation"
                    name="recommendation"
                    options={SortingAlphabatically(siteInspRecommendation)}
                    defaultValue={dataRecommendationDocument}
                    extraLabel="Remarks"
                    setDeveloperRemarks={setDeveloperRemarksDocument}
                    developerRemarks={
                      developerRemarksDocument
                        ? developerNocRemarks
                        : Array.isArray(documentRemarksData?.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0
                        ? documentRemarksData.DetailDataRemarks[documentRemarksData.DetailDataRemarks.length - 1]?.documentDetails?.developerRemarks
                        : documentRemarksData?.DetailDataRemarks?.documentDetails?.developerRemarks
                    }
                    setDataRecommendation={setDataRecommendationDocument}
                    {...props}
                    error={error}
                    setError={setError}
                  />
                )}
              />
              {!isCitizen && <DetailInfoTable detailData={documentRemarksData?.DetailDataRemarks} type="documentDetails" />}
            </React.Fragment>
          ) : (
            <ViewDocuments
              documentSection={documentSection}
              setIsPreviewLoading={setIsPreviewLoading}
              iframeSrc={iframeSrc}
              setIframeSrc={setIframeSrc}
              initialUrl={initialUrl}
            />
          )}
        </React.Fragment>
      );
      // return <Step2 formData={formData} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={!isCitizen} />;
    } else if (activeTab === 2) {
      return <CompoundingChecklist formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
    } else if (activeTab === 3) {
      return (
        <EmpIdentifyNoc
          formData={params}
          tenantId={tenantId}
          handleNoWorkflowNoc={handleNoWorkflowNoc}
          isJE={isJE}
          currentFormData={currentFormData}
        />
      );
    } else if (activeTab === 4) {
      return (
        <React.Fragment>
          <Step4Comp formData={params || formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} onSelect={onSelect} />
          {!isCitizen && (
            <React.Fragment>
              <RecommendationRemarksComponent
                title="Recommendation Details"
                label="Recommendation"
                name="recommendation" // just a field name, not value!
                defaultValue={dataRecommendation}
                options={SortingAlphabatically(siteInspRecommendation)}
                extraLabel="Remarks"
                setDeveloperRemarks={setDeveloperRemarks}
                developerRemarks={developerRemarks}
                setDataRecommendation={setDataRecommendation}
                names="multiSelectField"
                type="drawingDetails"
                buttonshow={true}
                onSaveClick={callDrawingDetailsAPI} // <-- parent callback
                handleTabChange={handleTabChange}
                nextTab={4}
              />
              <DrawingsDetailsTable detailData={siteDrawingRemarksData?.DetailDataRemarks} />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else if (activeTab === 5) {
      return (
        <React.Fragment>
          <BasicSiteInspectionReport
            formData={params}
            setCurrentTab={handleTabChange}
            setUpdatedInspectionReportData={setUpdatedInspectionReportData}
            callInspectionDetailsAPI={callInspectionDetailsAPI}
            userRolesArray={userRolesArray}
            onSelect={onSelect}
          />
          <DetailInfoTable detailData={siteInspectionRemarksData?.DetailDataRemarks} type="inspectionDetails" formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 6) {
      return (
        <React.Fragment>
          <PaymentHead
            tenantId={tenantId}
            formData={params}
            setTaxHead={setTaxHead}
            taxHead={taxHead}
            empRole={userRolesArray?.[0]?.code}
            isFeesEligible={isFeesEligible}
            onSelect={setParams}
            Modal={Modal}
            isValidEmp={isValidEmp}
            isCompounding={isCompounding}
          />
          <PaymentMemoTable formData={params} logoData={formData?.department == "DA" ? daLogo : avpLogo} />
          <RecommendationRemarksComponent
            title="Recommendation Details"
            label="Recommendation"
            name="recommendation" // just a field name, not value!
            options={SortingAlphabatically(siteInspRecommendation)}
            defaultValue={dataRecommendation}
            extraLabel="Remarks"
            setDeveloperRemarks={setDeveloperRemarks}
            developerRemarks={developerRemarks}
            setDataRecommendation={setDataRecommendation}
            onSaveClick={callPaymentDetailsAPI}
            buttonshow={true} // <-- parent callback
            error={error}
            setError={setError}
          />
          <DetailInfoTable detailData={paymentHeadRemarksData?.DetailDataRemarks} type="paymentDetails" />
        </React.Fragment>
      );
    } else if (activeTab === 7) {
      return (
        <div>
          <React.Fragment>
            <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"Compounding"} />
            <CollapsibleHistory
              formData={formData}
              callNotingDetailsAPI={callNotingDetailsAPI}
              developerRemarks={developerRemarks}
              setDeveloperRemarks={setDeveloperRemarks}
              notingRemarksData={notingRemarksData}
            />
            {formData?.status?.startsWith("APPLY_FOR_DSC") && (
              <DscLetters formData={formData} handleChange={handleTabChange} isEmployee={!isCitizen} />
            )}

            {/* {formData?.status?.startsWith("APPLY_FOR_DSC") && ( */}
            <CollapsibleAdditionalRemarks
              formData={params || formData}
              additionalComment={additionalComment}
              setAdditionalComment={setAdditionalComment}
              handleSubmit={() => {
                console.log("additionalComment12", additionalComment);
                if (additionalComment.trim()?.length === 0) {
                  return;
                }
                handleAdditionalComment();
              }}
            />
            {/* )} */}

            <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />
            <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
            <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
            <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />
          </React.Fragment>
        </div>
      );
    } else if (activeTab === 8) {
      return <AllRemarksList remarkDataResps={workflowDetails?.data} />;
    } else if (activeTab === 9) {
      return (
        <React.Fragment>
          <ChatBoard formData={formData} assignerToChatboard={workflowDetails?.data?.processInstances} />
        </React.Fragment>
      );
    }
    // else if(activeTab === 4){
    //   return <Step5 formData={params} handleSubTabChange={handleTabChange}/>
    // }
  };

  console.log("activeTab.........", activeTab);
  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <EmpTopBar formData={formData} />
      <FormStrip formName={t("Compounding")} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Compounding Checklist" />
          <PrimaryTab label="NOC Status" />
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Site Inspection" />
          <PrimaryTab label="Payment Head Compounding" />
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="Remarks History" />
          <PrimaryTab label="Chat Board" />
          {/* <PrimaryTab label="Letter and Plan" /> */}
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      {/* <StyledDivider /> */}
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {activeTab === 1 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedDocTab}
            onChange={(e, i) => handleSubDocTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabDocLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};
export default EmpCompoundingPortal;
